import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowRedemptionInfoDialogComponent } from './show-redemption-info-dialog.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ShowRedemptionInfoDialogComponent],
  exports: [ShowRedemptionInfoDialogComponent],
})
export class ShowRedemptionInfoDialogModule {}
